module.exports = __webpack_public_path__ + "81e9097b295a05b5017cb5651ce9e12a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sonnen.mp4
// module id = 256
// module chunks = 0